// returns auth headers using stored auth token
export function authHeaders() {
  const { token } = this.getToken()

  if (!token) return {}

  return { Authorization: `Bearer ${token}` }
}
